import { AppointmentDatePickerProps } from './types';
import { Container, Flexbox, Text, useResize } from '@morf/ui';
import { FC, memo } from 'react';
import { SchedulingDatePicker } from '../SchedulingDatePicker';
import { SchedulingTimezonePicker } from '../SchedulingTimezonePicker';
import { useTheme } from '@morf/theming';
import { useUrlParams } from '../../../components/helpers/useUrlParams';

const AppointmentDatePicker: FC<AppointmentDatePickerProps> = ({
  appointmentTypeName,
  monthlyAvailabilitySlots,
  isLoading,
  multiselect = false,
}) => {
  const theme = useTheme();
  const { hideCalendarTitle } = useUrlParams();

  const responsiveDatePicker = useResize({
    maxWidth: {
      xxl: '24.5rem',
      xl: '23rem',
      lg: '20rem',
      md: '18.5rem',
      sm: '24.5rem',
      xs: '24.5rem',
    },
  });

  return (
    <Flexbox
      direction='column'
      backgroundColor={theme.colors.ui.card}
      borderRadius={theme.container.borderRadius}
      borderColor={theme.container.borderColor}
      borderType={theme.container.borderType}
      borderWidth={theme.container.borderWidth}
      height='auto'
      {...responsiveDatePicker}
    >
      {!hideCalendarTitle && (
        <Container p={1.25} borderType='borderBottom'>
          <Text tag='h2' whiteSpace='nowrap'>
            {appointmentTypeName}
          </Text>
        </Container>
      )}

      <SchedulingDatePicker
        monthlyAvailabilitySlots={monthlyAvailabilitySlots}
        isLoading={isLoading}
        multiSelect={multiselect}
      />
      <Container p={1.25} borderType='borderTop'>
        <SchedulingTimezonePicker />
      </Container>
    </Flexbox>
  );
};

export const MemoizedAppointmentDatePicker = memo(AppointmentDatePicker);
